function formatAddress(address = {}) {
  const {country = "", locality = ""} = address;

  const addressParts = [locality, country];

  return addressParts.filter((part) => part).join(", ");
}

export default formatAddress;
